<template>
  <el-dialog class="continue-data-dialog" :fullscreen="true" @close="stopQuery = true" @closed="closeLine"
    @open="openEvent" title="连续采集" :visible.sync="lineVisible">
    <template slot="title">
      <span class="el-dialog__title">连续采集</span>
    </template>
    <div style="overflow-x: hidden;overflow-y: auto;height:100%">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane v-for="(channel) in channelList" :key="'ch'+channel.key+channel.pre" :label="channel.name"
              :name="channel.fkey">
            </el-tab-pane>
          </el-tabs>
        </el-col>
        <el-col :span="7">
          <el-date-picker v-model="timeRange" type="datetimerange" align="right" unlink-panels
            value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
            :default-time="['00:00:00', '23:59:59']">
          </el-date-picker>
        </el-col>
        <el-col :span="5">
          <el-button type="danger" size="mini" @click="stopSeriesClick('停止采集')">停止采集</el-button>
          <el-button type="primary" size="mini" @click="btnQuery">查询</el-button>
          <el-button type="success" size="mini" @click="exportDataList">导出</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="24" style="height:100%;">
        <el-col :span="24" style="height:260px;">
          <LineChart :title="LineChartData.title" :legend="LineChartData.legend" :xAxis="LineChartData.xAxis"
            :series="LineChartData.series" :yMax="LineChartData.yMax" :yMin="LineChartData.yMin" />
        </el-col>
        <el-col :span="24" style="height:300px;">
          <el-table v-loading="loadingProject" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
            :data="filterTableData" style="width: 100%" :row-class-name="tableRowClassName">
            <el-table-column type="index" label="序号" width="80" />
            <el-table-column prop="projectStationName" label="测站名称"></el-table-column>
            <el-table-column prop="projectPointName" label="测点名称"></el-table-column>
            <el-table-column prop="dataCreateTime" header-align="center" align="center" label="测量时间">
            </el-table-column>
            <el-table-column prop="projectPointDeviceInit" header-align="center" align="center" label="初始值">
              <template slot-scope="scope">
                <el-tag type="success" style="width: 66px; text-align: center" v-for="(item, index) in getPointDeviceInit(
                scope.row.projectPointDeviceInit
              )" :key="'init-val-' + index">{{ item }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="dataUpload" header-align="center" align="center" label="当前测值">
              <template slot-scope="scope">
                <el-tag type="warning" style="width: 66px; text-align: center" v-for="(item, index) in getDataUpload(
                scope.row.projectPointDeviceInit,
                scope.row.dataUpload,
                scope.row.projectPointDeviceType
              )" :key="'upload-val-' + index">{{ item }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="dataComputed" header-align="center" align="center" label="监测值">
              <template slot-scope="scope">
                <el-tag v-if="'-' === scope.row.dataUpload" type="primary" style="width: 110px; text-align: center"> -
                </el-tag>
                <el-tag v-else v-for="(v,index) in scope.row.dataComputed.split(',')" :key="'dataComputed'+v+index"
                  type="primary" style="width: 100px; text-align: center">
                  {{ v }}{{ scope.row.projectPointUnit }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="projectPointUpperLimit" header-align="center" align="center" label="上限值">
              <template slot-scope="scope">{{getUpperData(scope.row)}}</template>
            </el-table-column>
            <el-table-column prop="projectPointLowerLimit" header-align="center" align="center" label="下限值">
              <template slot-scope="scope">{{ getLowerData(scope.row)}}</template>
            </el-table-column>
          </el-table>
          <div style="text-align: right">
            <el-pagination @size-change="handleSizeChange" :current-page="currentPage"
              @current-change="handleCurrentChange" :page-sizes="[1, 2, 5, 10, 20, 50, 100]" :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper" :page-count="pageCount"></el-pagination>
          </div>
        </el-col>
      </el-row>
    </div>
  </el-dialog>
</template>
<script>
import { queryData, queryLineData } from "@/api/dataApi";
import LineChart from "@/components/LineChart2";
import * as dayjs from "dayjs";
import { stopSeriesRequest } from "@/api/messageApi";
import { FORMULA_LIST } from "../../station/pointPage";
import { getUpNumber } from "@/common/js/XlogCommon";

export default {
  name: "Continue",
  components: { LineChart },
  props: {
    dialogTableVisible: {
      type: Boolean,
      default: true
    },
    channelList: {
      type: Array,
      default: () => []
    },
    projectId: {
      type: String,
      require: true
    },
    projectName: {
      type: String,
      require: true
    },
    stationId: {
      type: String
    },
    start: {
      type: String
    },
    pointList: {
      type: Array,
      require: true
    }
  },
  watch: {
    start: function (newVal, oldVal) {
      this.startTime = newVal;
      const end = dayjs().add(1, "day").format("YYYY-MM-DD HH:mm:ss");
      this.endTime = end;
      this.timeRange = [newVal, end];
    },
    dialogTableVisible: function (newVal, oldVal) {
      this.lineVisible = newVal;
    },
    channelList: function (newVal, oldVal) {
      if (newVal != null && newVal.length > 0) {
        this.activeName = newVal[0].fkey;
        newVal.forEach(item => {
          this.seriesDataMap[item.fkey] = {};
        });
      }
    }
  },
  data() {
    return {
      activeName: "",
      lineVisible: false,
      timeRange: [],
      filterTableData: [],
      loadingProject: false,
      loopTimerList: [],
      stopQuery: false,
      queryTimeNumber: undefined,
      seriesDataMap: {},
      currentPage: 1,
      pageSize: 5,
      pageCount: 0,
      startTime: "",
      endTime: "",
      formulaList: FORMULA_LIST,
      LineChartData: {
        title: "监控曲线",
        legend: ["bat"],
        xAxis: [],
        series: [],
        yMax: undefined,
        yMin: undefined,
      },
    };
  },
  mounted() {
    console.log("open");
  },
  methods: {
    closeLine() {
      this.stopQuery = true;
      this.$emit("update:closeLine", false);
    },
    openEvent() {
      this.stopQuery = false;
      this.loadDataList();
    },
    exportDataList() {
      const param = "projectId=" + this.projectId +
        "&projectName=" + this.projectName +
        "&stationId=" + this.stationId +
        "&stationName=" + this.stationId +
        "&start=" + this.timeRange[0] +
        "&end=" + this.timeRange[1] +
        "&series=true" +
        "&pointId="
        ;
      window.open("/admin/data/query/export?" + param);
    },
    btnQuery() {
      this.startTime = this.timeRange[0];
      this.endTime = this.timeRange[1];
      this.loadDataList();
    },
    loadDataList() {
      if (this.stopQuery) {
        clearTimeout(this.queryTimeNumber);
        return false;
      }

      this.channelList.forEach(item => {
        // console.log("load data:" + item.key);
        queryData({
          series: true,
          projectId: this.projectId,
          stationId: this.stationId,
          pointId: item.key,
          dataIndex: item.idx,
          pageIndex: this.currentPage,
          pageSize: this.pageSize,
          start: this.startTime,
          end: this.endTime
        }).then(res => {
          const resp = res.data;
          if (resp.code === 200) {
            const tableData = {
              data: resp.content,
              count: parseInt(resp.ext1)
            };
            this.seriesDataMap[item.fkey].table = tableData;
            if (this.activeName === item.key) {
              this.filterTableData = tableData.data;
            }
          } else {
            this.$message.warning(resp.msg ? resp.msg : "未加载到数据");
          }
        })
          .catch(() => {
            this.$message.error("页面异常");
          });

        queryLineData({
          series: true,
          projectId: this.projectId,
          stationId: this.stationId,
          pointId: item.key,
          dataIndex: item.idx,
          start: this.startTime,
          end: this.endTime
        }).then(res => {
          const response = res.data;
          const row = this.pointList.find(p => p.projectPointId === item.key);

          const dataMax = response.content.series.filter(f => !isNaN(f) && f !== null).reduce((m, a) => Math.max(m, a));
          const dataMin = response.content.series.filter(f => !isNaN(f) && f !== null).reduce((m, a) => Math.min(m, a));
          const max = parseFloat(this.getUpperDataNoUnit(row, 0));
          const min = parseFloat(this.getLowerDataNoUnit(row, 0));
          const yValMax = getUpNumber(parseFloat((((dataMax) > max ? dataMax : max) * 1.2)), 4);
          const yValMin = getUpNumber(parseFloat((((dataMin) < min ? dataMin : min) * (min > 0 ? 0.8 : 1.2))), 4);

          const LineChartData = {};
          LineChartData.title = `${row.projectPointName}${item.pre} 连续采集曲线`;
          LineChartData.xAxis = response.content.x;
          LineChartData.series =
            [
              {
                name: row.projectPointName,
                type: "line",
                connectNulls: true,
                smooth: true,
                markLine: {
                  data: [
                    {
                      label: {
                        show: true,
                        position: "start",
                        formatter: "上限:{c}",
                        distance: [-50, 150]
                      },

                      lineStyle: {
                        color: "red",
                      },
                      yAxis: max
                    },
                    {
                      label: {
                        show: true,
                        position: "start",
                        formatter: "下限:{c}",
                        distance: [-50, 150]
                      },
                      yAxis: min
                    }
                  ]
                },
                data: response.content.series
              }
            ];
          LineChartData.legend = [row.projectPointName];
          LineChartData.yMax = yValMax;
          LineChartData.yMin = yValMin;

          this.seriesDataMap[item.fkey].line = LineChartData;
          if (this.activeName === item.key) {
            this.handleClick(item.key, true);
          }
        });
      });
      this.queryTimeNumber = setTimeout(this.loadDataList.bind(this), 20000);
    },

    handleClick(same) {
      const v = this.activeName;
      console.log("选择的tab是", v, this.seriesDataMap[v]);
      this.LineChartData = this.seriesDataMap[v].line;
      this.$set(this.LineChartData, "xAxis", this.seriesDataMap[v].line.xAxis);
      this.$set(this.LineChartData, "series", this.seriesDataMap[v].line.series);
      this.filterTableData = this.seriesDataMap[v].table.data;
      this.pageCount = this.seriesDataMap[v].table.count;
      if (!same) {
        this.currentPage = 1;
      }
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex === 1) {
        return "warning-row";
      } else if (rowIndex === 3) {
        return "success-row";
      }
      return "";
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.loadDataList();
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.loadDataList();
    },
    getPointDeviceInit(v) {
      const obj = JSON.parse(v);
      if (!obj) {
        return [];
      }
      const initObj = obj.find(v => v.key === "x");
      if (initObj && initObj.multiple) {
        return initObj.val.map(x => x.val);
      } else {
        return initObj ? [initObj.val] : [];
      }
    },
    getDataUpload(init, v, deviceType) {
      const obj = JSON.parse(init);
      if (!obj) {
        return [];
      }
      const initObj = obj.find(v => v.key === "x");
      const hasTemperature = obj.find(v => v.key === "t");
      if (initObj && (initObj.multiple || hasTemperature)) {
        const uploadVal = v.split(",");
        const selectedDevice = this.getDeviceConfigDetail(deviceType);
        if (!selectedDevice.customization) {
          return uploadVal.slice(0, uploadVal.length - 1 > 0 ? uploadVal.length - 1 : 1);
        } else {
          return uploadVal;
        }
      } else {
        return [v];
      }
    },
    stopSeriesClick(v) {
      // projectId: this.projectId,
      // stationId: this.stationId,

      stopSeriesRequest({
        stationId: this.stationId,
      }).then(res => {
        if (res.data.code !== 200) {
          this.$message.error({ showClose: true, duration: 6000, message: res.data.msg });
        } else {
          this.$message.success({
            showClose: true, duration: 6000, message: v + ": " + res.data.content
          });
        }
      }).catch(e => {
        this.$message.error(v + ":系统处理失败");
      });
    },
    getUpperData(row) {
      const selectedDevice = this.getDeviceConfigDetail(row.projectPointDeviceType);
      if (selectedDevice.customization) {
        const init = row.projectPointDeviceInit;
        const obj = JSON.parse(init);
        const initObj = obj.find(v => v.key === "upper");

        if (selectedDevice.hiddenUnit) {
          const unitObj = obj.find(v => v.key === "unit").val;
          const res = [];
          const u = initObj.val.map(u => u.val);
          for (let i = 0; i < u.length; i++) {
            res[i] = u[i] + unitObj[i].val;
          }
          return res.join(" , ");
        } else {
          return initObj.val.map(u => u.val + row.projectPointUnit).join(",");
        }
      } else {
        return row.projectPointUpperLimit + row.projectPointUnit;
      }
    },
    getUpperDataNoUnit(row, index) {
      const selectedDevice = this.getDeviceConfigDetail(row.projectPointDeviceType);
      if (selectedDevice.customization) {
        const init = row.projectPointDeviceInit;
        const obj = JSON.parse(init);
        const initObj = obj.find(v => v.key === "upper");
        return parseFloat(initObj.val.map(u => u.val)[index]).toFixed(2);
      } else {
        return row.projectPointUpperLimit;
      }
    },
    getLowerData(row) {
      const selectedDevice = this.getDeviceConfigDetail(row.projectPointDeviceType);
      if (selectedDevice.customization) {
        const init = row.projectPointDeviceInit;
        const obj = JSON.parse(init);
        const initObj = obj.find(v => v.key === "lower");

        if (selectedDevice.hiddenUnit) {
          const unitObj = obj.find(v => v.key === "unit").val;
          const res = [];
          const u = initObj.val.map(u => u.val);
          for (let i = 0; i < u.length; i++) {
            res[i] = u[i] + unitObj[i].val;
          }
          return res.join(" , ");
        } else {
          return initObj.val.map(u => u.val + row.projectPointUnit).join(",");
        }
      } else {
        return row.projectPointLowerLimit + row.projectPointUnit;
      }
    },
    getLowerDataNoUnit(row, index) {
      const selectedDevice = this.getDeviceConfigDetail(row.projectPointDeviceType);
      if (selectedDevice.customization) {
        const init = row.projectPointDeviceInit;
        const obj = JSON.parse(init);
        const initObj = obj.find(v => v.key === "lower");
        return parseFloat(initObj.val.map(u => u.val)[index]).toFixed(2);
      } else {
        return row.projectPointLowerLimit;
      }
    },
    getDeviceConfigDetail(id) {
      const selectedDevice = this.formulaList.find(
        v => v.val === id
      );
      return selectedDevice;
    }
  }
};
</script>
<style scoped>
.continue-data-dialog {
  height: 140vh;
}
.continue-data-dialog /deep/.el-dialog__body {
  padding: 5px 20px 20px 20px !important;
}
</style>
